import {IWindowRef} from './window-reference.interface';

export abstract class WindowRef {
  abstract get nativeWindow(): IWindowRef;
}

export class BrowserWindowRef extends WindowRef {
  get nativeWindow(): IWindowRef {
    return window as unknown as IWindowRef;
  }
}
